/*
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-05-08 23:02:46
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-09 15:23:02
 * @FilePath: \vue-privilege-routing\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from "../pages/login/index.vue"
import Register from "../pages/login/register.vue"
import Website from "../pages/website/website.vue"
import WebsiteAdvice from "../pages/website/websiteAdvice.vue"
import WebsiteCustomize from "../pages/website/websiteCustomize.vue"
import WebsiteTechnology from "../pages/website/websiteTechnology.vue"
import WebsiteCompany from "../pages/website/websiteCompany.vue"
import WebsiteInvest from "../pages/website/websiteInvest.vue"
import Home from "../pages/home"
import NotFound from "../pages/errorPage/404"
import Forbidden from "../pages/errorPage/403"
import Layout from "../pages/layout"


Vue.use(VueRouter)

// 初始化路由
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/website',
    name: 'Website',
    component: Website
  },
  {
    path: '/websiteAdvice',
    name: 'WebsiteAdvice',
    component: WebsiteAdvice
  },
  {
    path: '/websiteCustomize',
    name: 'WebsiteCustomize',
    component: WebsiteCustomize
  }
  ,
  {
    path: '/websiteTechnology',
    name: 'WebsiteTechnology',
    component: WebsiteTechnology
  },
  {
    path: '/websiteCompany',
    name: 'WebsiteCompany',
    component: WebsiteCompany
  },
  {
    path: '/websiteInvest',
    name: 'WebsiteInvest',
    component: WebsiteInvest
  }

]

/**
 * 根据用户的权限不同，所能看到的页面和可操作性也不同
 *  admin -> 所有页面都可以看得到
 *  vip -> 属于vip的权限
 *  svip -> 更多额vip的权限
 * 
 * addRouter()
 */
// 准备动态加载的路由
export const DynamicRoutes = [
    {
        path:"",
        component:Layout,
        name:'container',
        redirect:"home",
        meta:{
            requiresAuth:true,
            name:"星火商城"
        },
        children:[
            {
                path:"home",
                component:Home,
                name:"home",
                meta:{
                    // 匹配规则
                    name:"星火商城",
                    icon:"icon-name"
                }
            }
        ]
    },
    {
        path:"/403",
        component:Forbidden
    },
    {
        path:"*",
        component:NotFound
    }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
